import "@/app.scss";
import "@/axios";
import { IS_APP_KYC_MODE, IS_DEV } from "@/constants";
import "@/i18n";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { setDefaultOptions } from "date-fns";
import { TawkMessenger } from "@features/TawkMessenger/TawkMessenger";
import { MainLayout } from "@components/layouts/MainLayout/MainLayout";
import { Toaster } from "@components/Toaster/Toaster";
import { useGoogleAnalytics } from "@hooks/useGoogleAnalytics";
import { useAuthStore } from "@store/auth/auth";
import "flag-icons/css/flag-icons.min.css";
import React from "react";
import { RouterProvider } from "react-router-dom";
import { FeatureConfigProvider } from "./contexts/FeatureConfigContext/FeatureConfigProvider";
import { queryClient } from "./queryClient";
import { router } from "./router/router";

setDefaultOptions({ weekStartsOn: 1 });

export const App: React.FC = () => {
  const { token } = useAuthStore();
  useGoogleAnalytics();

  return (
    <QueryClientProvider client={queryClient}>
      <MainLayout>
        <FeatureConfigProvider>
          <React.Suspense fallback={<></>}>
            <RouterProvider router={router(token)} />
          </React.Suspense>
          {!IS_APP_KYC_MODE && <TawkMessenger />}
        </FeatureConfigProvider>
        <Toaster />
      </MainLayout>
      {IS_DEV && <ReactQueryDevtools />}
    </QueryClientProvider>
  );
};
